const customerMenu: any = {
  id: "customers",
  title: "Clienti",
  translate: "MENU.CUSTOMERS",
  type: "collapsible",
  icon: "smile",
  capability: "show_menu_customers",
  children: [
    {
      id: "list-customers",
      title: "Clienti",
      translate: "MENU.CUSTOMERS",
      type: "item",
      url: "dashboard/customers",
      capability: "show_customers_list",
    },
    {
      id: "customers-location",
      title: "Sedi",
      translate: "MENU.CUSTOMERS_LOCATION",
      type: "item",
      url: "dashboard/customers-location",
      capability: "show_customer_addresses_list",
    },
    {
      id: "customers-reference",
      title: "Referenti",
      translate: "MENU.CUSTOMERS_REFERENCE",
      type: "item",
      url: "dashboard/customers-reference",
      capability: "show_customer_referents_list",
    },
  ],
  order: 12,
};
export default customerMenu;
